{
  "id": "001",
  "title": "An Introduction",
  "unlocked": true,
  "layout": {
    "offset": "odd-row",
    "tiles": {
      "0": {
        "0": {
          "type": "tile",
          "id": "0cbb0588"
        },
        "1": {
          "type": "tile",
          "id": "9c7f7b9a"
        },
        "2": {
          "id": "1b291584",
          "type": "tile",
          "ref": {
            "id": "001-003",
            "offset": {
              "r": 1,
              "c": -1
            }
          }
        },
        "3": {
          "id": "c33f42c2",
          "type": "tile",
          "ref": {
            "id": "001-003",
            "offset": {
              "r": 1,
              "c": 0
            }
          }
        },
        "-1": {
          "type": "tile",
          "id": "da960fda"
        },
        "-2": {
          "type": "tile",
          "ref": {
            "id": "001-001",
            "offset": {
              "r": 1,
              "c": 0
            }
          },
          "id": "8f2cda31",
          "items": [
            {
              "type": "modifier",
              "modifier": {
                "type": "puzzle",
                "id": "001-002"
              },
              "id": "b224cae3"
            }
          ]
        },
        "-3": {
          "id": "57bb0429",
          "type": "tile",
          "ref": {
            "id": "001-001",
            "offset": {
              "r": 1,
              "c": -1
            }
          }
        }
      },
      "1": {
        "0": {
          "type": "tile",
          "id": "5c2510d3",
          "items": [
            {
              "type": "modifier",
              "modifier": {
                "type": "puzzle",
                "id": "001-001"
              },
              "id": "108d9afd"
            }
          ]
        },
        "1": {
          "id": "e21f9280",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": -1,
              "c": -3
            }
          }
        },
        "2": {
          "id": "55a0cecf",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": -1,
              "c": -2
            }
          }
        },
        "5": {
          "id": "51c0929a",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": -1,
              "c": 1
            }
          }
        },
        "6": {
          "id": "46963c5c",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": -1,
              "c": 2
            }
          },
          "modifiers": [
            {
              "type": "lock",
              "id": "7991b9b0"
            }
          ],
          "items": [
            {
              "type": "modifier",
              "modifier": {
                "type": "puzzle",
                "id": "001-009"
              },
              "id": "7dc9f107",
              "color": "#b400b4"
            }
          ]
        },
        "-1": {
          "id": "e3bec484",
          "type": "tile",
          "items": [
            {
              "id": "ddca0ca8",
              "type": "terminus",
              "openings": [
                {
                  "color": "#b400b4",
                  "direction": 1,
                  "toggled": true
                }
              ]
            }
          ],
          "modifiers": [
            {
              "id": "a05d39a2",
              "type": "sticky-items"
            },
            {
              "type": "toggle",
              "id": "3c658dae"
            }
          ]
        },
        "-3": {
          "id": "904e8357",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": -1,
              "c": 1
            }
          }
        },
        "-2": {
          "id": "0220c943",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": -1,
              "c": 2
            }
          }
        },
        "-7": {
          "id": "690c22b2",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": -1,
              "c": -3
            }
          }
        },
        "-6": {
          "id": "80603a48",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": -1,
              "c": -2
            }
          }
        }
      },
      "2": {
        "1": {
          "id": "63af4b07",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": 0,
              "c": -3
            }
          },
          "items": [
            {
              "type": "portal",
              "id": "647d5d1b"
            },
            {
              "type": "wall",
              "directions": [
                1
              ],
              "immutable": true,
              "id": "73aa41df"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "9f91a4f9"
            }
          ]
        },
        "2": {
          "id": "8a2041c5",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": 0,
              "c": -2
            }
          }
        },
        "3": {
          "id": "611a4233",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": 0,
              "c": -1
            }
          }
        },
        "5": {
          "id": "2e2f320b",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": 0,
              "c": 1
            }
          }
        },
        "6": {
          "id": "72c65ad0",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": 0,
              "c": 2
            }
          }
        },
        "7": {
          "id": "c63b4645",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": 0,
              "c": 3
            }
          }
        },
        "-3": {
          "id": "744fba7a",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": 0,
              "c": 1
            }
          },
          "modifiers": [
            {
              "type": "sticky-items",
              "id": "449c7a8c"
            }
          ],
          "items": [
            {
              "type": "modifier",
              "modifier": {
                "type": "puzzle",
                "id": "001-010"
              },
              "id": "3a9386ea",
              "color": "#0000ff"
            }
          ]
        },
        "-2": {
          "id": "70dbb697",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": 0,
              "c": 2
            }
          }
        },
        "-1": {
          "id": "02825cfd",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": 0,
              "c": 3
            }
          },
          "items": [
            {
              "type": "portal",
              "id": "9d1884cb"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "77fe4855"
            }
          ]
        },
        "-5": {
          "id": "33e38cc1",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": 0,
              "c": -1
            }
          }
        },
        "-6": {
          "id": "45b8cea9",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": 0,
              "c": -2
            }
          }
        },
        "-7": {
          "id": "c52c1877",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": 0,
              "c": -3
            }
          }
        }
      },
      "3": {
        "0": {
          "id": "eadb402e",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": -2,
              "c": 0
            }
          },
          "items": [
            {
              "type": "reflector",
              "rotation": -2,
              "id": "66a40a47"
            }
          ]
        },
        "1": {
          "id": "26bc177a",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": 1,
              "c": -3
            }
          }
        },
        "2": {
          "id": "19a43886",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": 1,
              "c": -2
            }
          }
        },
        "5": {
          "id": "8f490a68",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": 1,
              "c": 1
            }
          }
        },
        "6": {
          "id": "71763e51",
          "type": "tile",
          "ref": {
            "id": "001-008",
            "offset": {
              "r": 1,
              "c": 2
            }
          },
          "items": [
            {
              "type": "portal",
              "id": "4c4cbc1d"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "ad62bc38"
            }
          ]
        },
        "-3": {
          "id": "42aa42df",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": 1,
              "c": 1
            }
          }
        },
        "-2": {
          "id": "dbaeb3de",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": 1,
              "c": 2
            }
          }
        },
        "-6": {
          "id": "6f6a8255",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": 1,
              "c": -2
            }
          }
        },
        "-7": {
          "id": "db7f9826",
          "type": "tile",
          "ref": {
            "id": "001-009",
            "offset": {
              "r": 1,
              "c": -3
            }
          }
        },
        "-1": {
          "id": "92e29b3a",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": -2,
              "c": -1
            }
          },
          "items": [
            {
              "type": "reflector",
              "rotation": 2,
              "id": "3496158a"
            }
          ]
        }
      },
      "4": {
        "0": {
          "id": "5a1ac900",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": -1,
              "c": -1
            }
          },
          "items": [
            {
              "type": "filter",
              "color": "#ff0000",
              "id": "89da7379"
            }
          ]
        },
        "1": {
          "id": "1b76a8a0",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": -1,
              "c": 0
            }
          }
        },
        "-1": {
          "id": "bc09e30f",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": -1,
              "c": -2
            }
          }
        }
      },
      "5": {
        "0": {
          "id": "190532c5",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 0,
              "c": 0
            }
          },
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#b400b4",
                  "direction": 0,
                  "toggled": true
                }
              ],
              "id": "1a1e2ad5"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "fbce6330"
            }
          ]
        },
        "1": {
          "id": "84eab54c",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 0,
              "c": 1
            }
          }
        },
        "2": {
          "id": "97a17408",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 0,
              "c": 2
            }
          }
        },
        "-2": {
          "id": "c37a03f6",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 0,
              "c": -2
            }
          }
        },
        "-3": {
          "id": "c548f15d",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 0,
              "c": -3
            }
          },
          "items": [
            {
              "type": "portal",
              "id": "7280afcd"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "65aba170"
            }
          ]
        },
        "-1": {
          "id": "6ba442c5",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 0,
              "c": -1
            }
          },
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#b400b4",
                  "direction": 1,
                  "toggled": true
                }
              ],
              "id": "5a680d10"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "5cde9a8f"
            }
          ]
        }
      },
      "6": {
        "1": {
          "id": "706f6c74",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 1,
              "c": 0
            }
          }
        },
        "2": {
          "id": "961e9705",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 1,
              "c": 1
            }
          },
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 2
                }
              ],
              "id": "41f197e4"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-items",
              "id": "c69136f5"
            }
          ]
        },
        "3": {
          "id": "b44b0f4c",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 1,
              "c": 2
            }
          }
        },
        "-2": {
          "id": "255e99c6",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 1,
              "c": -3
            }
          },
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 5
                }
              ],
              "id": "e7f8c069"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-items",
              "id": "a7150226"
            }
          ]
        },
        "-1": {
          "id": "665ba31e",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 1,
              "c": -2
            }
          }
        },
        "-3": {
          "id": "b87f2624",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 1,
              "c": -4
            }
          }
        }
      },
      "7": {
        "0": {
          "id": "210e5463",
          "type": "tile",
          "ref": {
            "id": "001-010",
            "offset": {
              "r": -1,
              "c": 0
            }
          }
        },
        "1": {
          "id": "c5d2f81f",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 2,
              "c": 1
            }
          }
        },
        "2": {
          "id": "fb70627d",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 2,
              "c": 2
            }
          },
          "items": [
            {
              "type": "portal",
              "id": "810a1348"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "9c3823bc"
            }
          ]
        },
        "-1": {
          "id": "720d0180",
          "type": "tile",
          "ref": {
            "id": "001-010",
            "offset": {
              "r": -1,
              "c": -1
            }
          }
        },
        "-3": {
          "id": "314490e3",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 2,
              "c": -3
            }
          }
        },
        "-2": {
          "id": "e7e92e61",
          "type": "tile",
          "ref": {
            "id": "001-011",
            "offset": {
              "r": 2,
              "c": -2
            }
          }
        }
      },
      "8": {
        "0": {
          "id": "75df857a",
          "type": "tile",
          "ref": {
            "id": "001-010",
            "offset": {
              "r": 0,
              "c": 0
            }
          },
          "items": [
            {
              "type": "modifier",
              "id": "6776e546",
              "modifier": {
                "type": "puzzle",
                "id": "001-011"
              },
              "color": "#ff0000"
            },
            {
              "type": "wall",
              "directions": [
                0,
                1,
                2,
                3,
                4
              ],
              "immutable": true,
              "id": "52f60a73"
            }
          ],
          "modifiers": [
            {
              "type": "lock",
              "id": "a4ba32c5"
            }
          ]
        },
        "1": {
          "id": "43142953",
          "type": "tile",
          "ref": {
            "id": "001-010",
            "offset": {
              "r": 0,
              "c": 1
            }
          },
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 5
                }
              ],
              "id": "7cc24906"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-items",
              "id": "f5a8c165"
            }
          ]
        },
        "-1": {
          "id": "da8da7c6",
          "type": "tile",
          "ref": {
            "id": "001-010",
            "offset": {
              "r": 0,
              "c": -1
            }
          },
          "items": [
            {
              "type": "portal",
              "id": "047adf20"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "1e268ffb"
            }
          ]
        }
      },
      "9": {
        "0": {
          "id": "c92e21e3",
          "type": "tile",
          "ref": {
            "id": "001-010",
            "offset": {
              "r": 1,
              "c": 0
            }
          }
        },
        "-1": {
          "id": "62c320fa",
          "type": "tile",
          "ref": {
            "id": "001-010",
            "offset": {
              "r": 1,
              "c": -1
            }
          }
        }
      },
      "-1": {
        "0": {
          "type": "tile",
          "id": "c9bedf13"
        },
        "1": {
          "id": "fb798c61",
          "type": "tile",
          "ref": {
            "id": "001-003",
            "offset": {
              "r": 0,
              "c": -1
            }
          }
        },
        "2": {
          "id": "dbf74c17",
          "type": "tile",
          "ref": {
            "id": "001-003",
            "offset": {
              "r": 0,
              "c": 0
            }
          }
        },
        "3": {
          "id": "a4f181e1",
          "type": "tile",
          "ref": {
            "id": "001-003",
            "offset": {
              "r": 0,
              "c": 1
            }
          }
        },
        "-1": {
          "items": [
            {
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 3,
                  "toggled": true
                }
              ],
              "type": "terminus",
              "id": "9f234017"
            }
          ],
          "type": "tile",
          "id": "349a7a4a",
          "modifiers": [
            {
              "type": "immutable",
              "id": "8a23fd5a"
            }
          ]
        },
        "-3": {
          "id": "98c1b870",
          "type": "tile",
          "ref": {
            "id": "001-001",
            "offset": {
              "r": 0,
              "c": 0
            }
          }
        },
        "-2": {
          "id": "f7b48b08",
          "type": "tile",
          "ref": {
            "id": "001-001",
            "offset": {
              "r": 0,
              "c": 1
            }
          },
          "items": [
            {
              "type": "reflector",
              "id": "9f03415b"
            }
          ]
        },
        "-4": {
          "id": "a7f644b8",
          "type": "tile",
          "ref": {
            "id": "001-001",
            "offset": {
              "r": 0,
              "c": -1
            }
          },
          "items": [
            {
              "type": "portal",
              "id": "c7c14bce"
            },
            {
              "type": "wall",
              "directions": [
                2
              ],
              "immutable": true,
              "id": "827a578f"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "5eb6ae84"
            }
          ]
        }
      },
      "-2": {
        "0": {
          "id": "1a2e1e12",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 2,
              "c": 0
            }
          }
        },
        "1": {
          "id": "522b600d",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 2,
              "c": 1
            }
          },
          "items": [
            {
              "type": "reflector",
              "id": "fd8cc81f"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "c442ea9c"
            }
          ]
        },
        "2": {
          "id": "3622ae8a",
          "type": "tile",
          "ref": {
            "id": "001-003",
            "offset": {
              "r": -1,
              "c": -1
            }
          }
        },
        "3": {
          "id": "1340ed3e",
          "type": "tile",
          "ref": {
            "id": "001-003",
            "offset": {
              "r": -1,
              "c": 0
            }
          },
          "modifiers": [
            {
              "type": "lock",
              "id": "3e1388e9"
            }
          ],
          "items": [
            {
              "type": "modifier",
              "modifier": {
                "type": "puzzle",
                "id": "001-004"
              },
              "id": "aaf67885",
              "color": "#b400b4"
            }
          ]
        },
        "-2": {
          "id": "2eb11c84",
          "type": "tile",
          "ref": {
            "id": "001-001",
            "offset": {
              "r": -1,
              "c": 0
            }
          }
        },
        "-3": {
          "id": "e2e2cc4d",
          "type": "tile",
          "ref": {
            "id": "001-001",
            "offset": {
              "r": -1,
              "c": -1
            }
          }
        },
        "-1": {
          "id": "ea370bb7",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 2,
              "c": -1
            }
          }
        }
      },
      "-4": {
        "0": {
          "id": "04c7d967",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 0,
              "c": 0
            }
          },
          "items": [
            {
              "type": "reflector",
              "id": "7d9158ff"
            }
          ]
        },
        "1": {
          "id": "e0e00401",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 0,
              "c": 1
            }
          }
        },
        "2": {
          "id": "5acc1407",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 0,
              "c": 2
            }
          },
          "modifiers": [
            {
              "type": "sticky-items",
              "id": "750a6fcd"
            }
          ]
        },
        "-1": {
          "id": "6c632460",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 0,
              "c": -1
            }
          }
        },
        "-2": {
          "id": "1652ec72",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 0,
              "c": -2
            }
          }
        }
      },
      "-3": {
        "0": {
          "id": "d0b13fc4",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 1,
              "c": 0
            }
          }
        },
        "1": {
          "id": "453b4d64",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 1,
              "c": 1
            }
          }
        },
        "-1": {
          "id": "59e60928",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 1,
              "c": -1
            }
          }
        },
        "-2": {
          "id": "e04bf3e8",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": 1,
              "c": -2
            }
          }
        }
      },
      "-5": {
        "0": {
          "id": "1848a6ad",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": -1,
              "c": 0
            }
          },
          "items": [
            {
              "type": "modifier",
              "id": "3713ecb1",
              "modifier": {
                "type": "puzzle",
                "id": "001-003"
              }
            }
          ]
        },
        "1": {
          "id": "6a9d44bf",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": -1,
              "c": 1
            }
          }
        },
        "2": {
          "id": "e1f07200",
          "type": "tile",
          "ref": {
            "id": "001-004",
            "offset": {
              "r": 1,
              "c": -1
            }
          },
          "items": [
            {
              "type": "reflector",
              "id": "52deb9ee"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-modifiers",
              "id": "cc49f40d"
            }
          ]
        },
        "3": {
          "id": "926dd5c2",
          "type": "tile",
          "ref": {
            "id": "001-004",
            "offset": {
              "r": 1,
              "c": 0
            }
          },
          "items": [
            {
              "id": "4f988330",
              "type": "reflector"
            }
          ]
        },
        "-1": {
          "id": "a7ae7f64",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": -1,
              "c": -1
            }
          },
          "items": [
            {
              "type": "wall",
              "directions": [
                0
              ],
              "immutable": true,
              "id": "a79519b2"
            }
          ]
        },
        "-2": {
          "id": "ee57363a",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": -1,
              "c": -2
            }
          }
        },
        "-3": {
          "id": "2b3fd31d",
          "type": "tile",
          "ref": {
            "id": "001-005",
            "offset": {
              "r": 1,
              "c": 0
            }
          },
          "items": [
            {
              "type": "reflector",
              "id": "acf97ed3"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "547ed001"
            }
          ]
        },
        "-4": {
          "id": "15777e85",
          "type": "tile",
          "ref": {
            "id": "001-005",
            "offset": {
              "r": 1,
              "c": -1
            }
          }
        }
      },
      "-6": {
        "0": {
          "id": "75667c33",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": -2,
              "c": 0
            }
          }
        },
        "1": {
          "id": "082207e9",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": -2,
              "c": 1
            }
          },
          "items": [
            {
              "type": "reflector",
              "rotation": -2,
              "id": "5ee9afde"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "91002e9a"
            }
          ]
        },
        "2": {
          "type": "tile",
          "ref": {
            "id": "001-004",
            "offset": {
              "r": 0,
              "c": -1
            }
          },
          "id": "da5ab990",
          "items": [
            {
              "type": "reflector",
              "id": "90272626"
            }
          ]
        },
        "3": {
          "id": "f7e82775",
          "type": "tile",
          "ref": {
            "id": "001-004",
            "offset": {
              "r": 0,
              "c": 0
            }
          }
        },
        "4": {
          "id": "a6a13b50",
          "type": "tile",
          "ref": {
            "id": "001-004",
            "offset": {
              "r": 0,
              "c": 1
            }
          },
          "modifiers": [
            {
              "type": "lock",
              "id": "4cc3d75b"
            }
          ],
          "items": [
            {
              "type": "modifier",
              "modifier": {
                "type": "puzzle",
                "id": "001-005"
              },
              "id": "b9513437",
              "color": "#0000ff"
            }
          ]
        },
        "-1": {
          "id": "234b7936",
          "type": "tile",
          "ref": {
            "id": "001-002",
            "offset": {
              "r": -2,
              "c": -1
            }
          }
        },
        "-2": {
          "type": "tile",
          "ref": {
            "id": "001-005",
            "offset": {
              "r": 0,
              "c": 1
            }
          },
          "items": [
            {
              "type": "reflector",
              "id": "049ef19a"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "c32c9a6f"
            }
          ],
          "id": "a1a47835"
        },
        "-4": {
          "id": "d04577a8",
          "type": "tile",
          "ref": {
            "id": "001-005",
            "offset": {
              "r": 0,
              "c": -1
            }
          }
        }
      },
      "-7": {
        "0": {
          "id": "07559685",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": 1,
              "c": 0
            }
          },
          "modifiers": [
            {
              "type": "immutable",
              "id": "e780351b"
            }
          ]
        },
        "1": {
          "id": "8472fea8",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": 1,
              "c": 1
            }
          },
          "items": [
            {
              "type": "reflector",
              "rotation": 2,
              "id": "03e47eba"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "7e6db0d4"
            }
          ]
        },
        "2": {
          "id": "4c7af20d",
          "type": "tile",
          "ref": {
            "id": "001-004",
            "offset": {
              "r": -1,
              "c": -1
            }
          }
        },
        "3": {
          "id": "ee3c0f2f",
          "type": "tile",
          "ref": {
            "id": "001-004",
            "offset": {
              "r": -1,
              "c": 0
            }
          }
        },
        "-3": {
          "id": "f272960c",
          "type": "tile",
          "ref": {
            "id": "001-005",
            "offset": {
              "r": -1,
              "c": 0
            }
          },
          "modifiers": [
            {
              "type": "sticky-items",
              "id": "10279b1f"
            }
          ],
          "items": [
            {
              "type": "modifier",
              "id": "851f02cc",
              "modifier": {
                "type": "puzzle",
                "id": "001-006"
              },
              "color": "#b400b4"
            }
          ]
        },
        "-4": {
          "id": "671c53b3",
          "type": "tile",
          "ref": {
            "id": "001-005",
            "offset": {
              "r": -1,
              "c": -1
            }
          }
        },
        "-1": {
          "id": "ae9deac9",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": 1,
              "c": -1
            }
          },
          "modifiers": [
            {
              "type": "immutable",
              "id": "7303dcd3"
            }
          ]
        },
        "-2": {
          "id": "f62e3a1a",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": 1,
              "c": -2
            }
          },
          "modifiers": [
            {
              "type": "immutable",
              "id": "01ff72f0"
            }
          ]
        }
      },
      "-8": {
        "0": {
          "id": "31fddfab",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": 0,
              "c": 0
            }
          },
          "items": [
            {
              "type": "modifier",
              "id": "9791a1d0",
              "color": "#0000ff",
              "modifier": {
                "type": "puzzle",
                "id": "001-007"
              }
            },
            {
              "type": "wall",
              "directions": [
                0,
                1
              ],
              "immutable": true,
              "id": "af0848a4"
            }
          ],
          "modifiers": [
            {
              "type": "lock",
              "id": "1a24d383"
            }
          ]
        },
        "1": {
          "id": "7debc40d",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": 0,
              "c": 1
            }
          },
          "items": [
            {
              "type": "filter",
              "color": "#0000ff",
              "id": "c2afe8b1"
            }
          ]
        },
        "2": {
          "id": "4d3d4d5c",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": 0,
              "c": 2
            }
          },
          "modifiers": [
            {
              "type": "immutable",
              "id": "2928dc2a"
            }
          ]
        },
        "-1": {
          "id": "9a141161",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": 0,
              "c": -1
            }
          },
          "items": [
            {
              "type": "reflector",
              "id": "09565917"
            }
          ]
        },
        "-2": {
          "id": "4278d79d",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": 0,
              "c": -2
            }
          }
        }
      },
      "-9": {
        "0": {
          "id": "9742e8a6",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": -1,
              "c": 0
            }
          }
        },
        "1": {
          "id": "78e0360f",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": -1,
              "c": 1
            }
          }
        },
        "2": {
          "id": "ff1eab33",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": -1,
              "c": 2
            }
          },
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#ff0000",
                  "direction": 4,
                  "toggled": true
                }
              ],
              "id": "8cd594c8"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "031f4edb"
            }
          ]
        },
        "-1": {
          "id": "55998903",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": -1,
              "c": -1
            }
          }
        },
        "-2": {
          "id": "3f752831",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": -1,
              "c": -2
            }
          }
        },
        "-3": {
          "id": "d8d75757",
          "type": "tile",
          "ref": {
            "id": "001-006",
            "offset": {
              "r": -1,
              "c": -3
            }
          }
        }
      },
      "-11": {
        "0": {
          "id": "f0d256ba",
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": 0,
              "c": 0
            }
          }
        },
        "1": {
          "id": "72c3c916",
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": 0,
              "c": 1
            }
          }
        },
        "-2": {
          "id": "0ed739c7",
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": 0,
              "c": -2
            }
          }
        },
        "-1": {
          "id": "fb4b5a5c",
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": 0,
              "c": -1
            }
          }
        }
      },
      "-10": {
        "0": {
          "id": "4f76111a",
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": 1,
              "c": -1
            }
          }
        },
        "1": {
          "id": "fe092f90",
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": 1,
              "c": 0
            }
          }
        },
        "2": {
          "id": "65654f82",
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": 1,
              "c": 1
            }
          },
          "items": [
            {
              "type": "portal",
              "id": "ececb123"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "4f4cf79c"
            }
          ]
        },
        "-1": {
          "id": "16730a74",
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": 1,
              "c": -2
            }
          },
          "items": [
            {
              "type": "portal",
              "id": "fcdb63c0"
            },
            {
              "type": "wall",
              "directions": [
                2
              ],
              "immutable": true,
              "id": "f2e60645"
            }
          ],
          "modifiers": [
            {
              "type": "immutable",
              "id": "0ada3a55"
            }
          ]
        }
      },
      "-12": {
        "0": {
          "id": "3e72d7db",
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": -1,
              "c": -1
            }
          },
          "items": [
            {
              "type": "modifier",
              "modifier": {
                "type": "puzzle",
                "id": "001-008"
              },
              "id": "d7f13379"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-items",
              "id": "1f98e745"
            }
          ]
        },
        "1": {
          "id": "a7d5efb6",
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": -1,
              "c": 0
            }
          },
          "items": [
            {
              "type": "portal",
              "id": "8a7251a8",
              "direction": 4
            },
            {
              "type": "wall",
              "directions": [
                5
              ],
              "immutable": true,
              "id": "5cd15cce"
            }
          ],
          "modifiers": [
            {
              "type": "sticky-items",
              "id": "b283f34c"
            }
          ]
        },
        "-1": {
          "id": "41281869",
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": -1,
              "c": -2
            }
          }
        },
        "-2": {
          "type": "tile",
          "ref": {
            "id": "001-007",
            "offset": {
              "r": -1,
              "c": -3
            }
          },
          "id": "6ce87703"
        }
      }
    },
    "imports": [
      {
        "id": "001-001",
        "offset": {
          "r": -1,
          "c": -3
        },
        "filters": [
          {
            "type": "tile",
            "name": "in-solution",
            "inSolution": true
          },
          {
            "type": "puzzle",
            "name": "unlocked",
            "unlocked": true
          }
        ]
      },
      {
        "id": "001-002",
        "offset": {
          "r": -4,
          "c": 0
        },
        "filters": [
          {
            "type": "tile",
            "name": "in-solution",
            "inSolution": true
          },
          {
            "type": "puzzle",
            "name": "unlocked",
            "unlocked": true
          }
        ]
      },
      {
        "id": "001-003",
        "offset": {
          "r": -1,
          "c": 2
        },
        "filters": [
          {
            "type": "tile",
            "name": "in-solution",
            "inSolution": true
          },
          {
            "type": "puzzle",
            "name": "unlocked",
            "unlocked": true
          }
        ]
      },
      {
        "id": "001-004",
        "offset": {
          "r": -6,
          "c": 3
        },
        "filters": [
          {
            "type": "tile",
            "name": "in-solution",
            "inSolution": true
          },
          {
            "type": "puzzle",
            "name": "unlocked",
            "unlocked": true
          }
        ]
      },
      {
        "id": "001-005",
        "offset": {
          "r": -6,
          "c": -3
        },
        "filters": [
          {
            "type": "tile",
            "name": "in-solution",
            "inSolution": true
          },
          {
            "type": "puzzle",
            "name": "unlocked",
            "unlocked": true
          }
        ]
      },
      {
        "id": "001-006",
        "offset": {
          "r": -8,
          "c": 0
        },
        "filters": [
          {
            "type": "puzzle",
            "name": "unlocked",
            "unlocked": true
          },
          {
            "type": "tile",
            "name": "in-solution",
            "inSolution": true
          }
        ]
      },
      {
        "id": "001-007",
        "offset": {
          "r": -11,
          "c": 0
        },
        "filters": [
          {
            "type": "tile",
            "name": "in-solution",
            "inSolution": true
          },
          {
            "type": "puzzle",
            "name": "unlocked",
            "unlocked": true
          }
        ]
      },
      {
        "id": "001-008",
        "offset": {
          "r": 2,
          "c": 4
        },
        "filters": [
          {
            "type": "tile",
            "name": "in-solution",
            "inSolution": true
          },
          {
            "type": "puzzle",
            "name": "unlocked",
            "unlocked": true
          }
        ]
      },
      {
        "id": "001-009",
        "offset": {
          "r": 2,
          "c": -4
        },
        "filters": [
          {
            "type": "tile",
            "name": "in-solution",
            "inSolution": true
          },
          {
            "type": "puzzle",
            "name": "unlocked",
            "unlocked": true
          }
        ]
      },
      {
        "id": "001-010",
        "offset": {
          "r": 8,
          "c": 0
        },
        "filters": [
          {
            "type": "tile",
            "name": "in-solution",
            "inSolution": true
          },
          {
            "type": "puzzle",
            "name": "unlocked",
            "unlocked": true
          }
        ]
      },
      {
        "id": "001-011",
        "offset": {
          "r": 5,
          "c": 0
        },
        "filters": [
          {
            "type": "tile",
            "name": "in-solution",
            "inSolution": true
          },
          {
            "type": "puzzle",
            "name": "unlocked",
            "unlocked": true
          }
        ]
      }
    ],
    "modifiers": [
      {
        "type": "rotate",
        "filters": [
          {
            "type": "import",
            "name": "unlocked",
            "id": "001-001",
            "unlocked": true
          }
        ],
        "id": "201bce1a",
        "clockwise": false
      },
      {
        "type": "swap",
        "filters": [
          {
            "type": "import",
            "name": "unlocked",
            "id": "001-002",
            "unlocked": true
          }
        ],
        "id": "aa925e09"
      },
      {
        "type": "move",
        "filters": [
          {
            "type": "import",
            "name": "unlocked",
            "id": "001-003",
            "unlocked": true
          }
        ],
        "id": "ccaf2c87"
      },
      {
        "type": "toggle",
        "filters": [
          {
            "type": "import",
            "name": "unlocked",
            "id": "001-010",
            "unlocked": true
          }
        ],
        "id": "6928c154"
      }
    ]
  },
  "version": 2,
  "requirements": [
    {
      "type": "connections",
      "amount": 4
    }
  ]
}
